<form #documentClassificationForm="ngForm">
    <section class="tw-flex tw-flex-col tw-basis-full tw-h-full">
        <section>
            <section class="tw-flex tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                <div class="tw-w-full">
                    <label>Show In Document Types Used in Document
                        Classification Scanning</label>
                    <p-selectButton [options]="defaultSelectButtonOptions"
                        [(ngModel)]="documentClassification.scanning.visible" name="scanningVisible"
                        [disabled]="!active" optionValue="value"></p-selectButton>
                </div>
            </section>
        </section>

        <section>
            <section class="tw-flex  tw-flex-col tw-p-2 tw-mb-4 tw-ml-4">
                <div class="tw-w-full">
                    <label>Show In Document Types Used in Document
                        Classification Upload</label>
                    <p-selectButton [options]="defaultSelectButtonOptions"
                        [(ngModel)]="documentClassification.upload.visible" name="uploadVisible" [disabled]="!active"
                        optionValue="value"></p-selectButton>
                </div>
            </section>
        </section>

        <p-toolbar>
            <div class="tw-text-right tw-w-[95%] tw-mt-5 tw-row-span-4">
                <button [disabled]="!active || !documentClassificationForm.dirty" pButton icon="fal fa-save"
                    label="Save" (click)="saveChanges($event)" class="tw-mr-2"></button>
                <button [disabled]="!active || !documentClassificationForm.dirty" pButton icon="fal fa-undo"
                    label="Cancel" (click)="resetForm()" class="p-button-warning p-button-outlined tw-mr-2"></button>
                <button [disabled]="documentTypeId === 0" pButton icon="fal fa-trash" label="Delete"
                    (click)="deleteClassification()" class="p-button-warning p-button-outlined tw-mr-2"></button>
            </div>
        </p-toolbar>

    </section>
</form>

<p-confirmDialog key="ClassificationdDeleteDialog" appendTo="body" header="Delete Classification Configuration"
    message="Are you sure you want to delete this?" rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>
